define('entities/webshop/products',[
  'app',
  'backbone',
  'settings',
  'underscore',
  'backboneRelational'
], function (
  App,
  Backbone,
  Settings,
  _
) {
  'use strict';

  var app;
  if (Backbone.Relational.store._modelScopes && Backbone.Relational.store._modelScopes.length > 0) {
    app = {ns: Backbone.Relational.store._modelScopes[0]};
  } else {
    app = {ns: {}};
    Backbone.Relational.store.addModelScope(app.ns);
  }

  //-----------------

  app.ns.WebshopProduct = Backbone.RelationalModel.extend({
    idAttribute: 'id',

    fetch: function () {
      var params = {
        locale: Settings.get('lang'),
        id: this.getId()
      };

      this.url = Settings.url('compuzz2', 'webshop/product/get', params);
      return Backbone.Model.prototype.fetch.call(this);
    },

    parse: function (response, options) {
      if (response)
        API.create(response);

      return Backbone.Model.prototype.parse.call(this, response, options);
    },

    getId: function () {
      return parseInt(this.get('id'), 10);
    },

    getCode: function () {
      return this.get('code');
    },

    getStatus: function () {
      return this.get('status');
    },

    setStatus: function (status) {
      var defer = $.Deferred();

      if (this.getStatus() === status) {
        defer.resolve();
        return defer.promise();
      }

      var data = {
        code: this.getCode(),
        status: status
      };

      $.ajax({
        type: 'PUT',
        url: Settings.url('compuzz2', 'webshop/product/status/update'),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function () {
          defer.resolve();
        },
        error: function (data) {
          defer.reject(data.responseJSON.message);
        }
      });
      return defer.promise();
    },

    getDefaultCategoryId: function () {
      if(this.get('defaultCategoryId'))
        return parseInt(this.get('defaultCategoryId'), 10);
      else
        return null;
    },

    getDefaultCategoryCode: function () {
      if (this.get('defaultCategoryCode'))
        return this.get('defaultCategoryCode');
      else
        return '';
    },

    // List of {id, code} the product currently belongs to (default category
    // included). Populated by webshop/products/search. Kept as a plain
    // attribute so the "products in categories" grid can mutate it optimistically.
    getCategories: function () {
      var categories = this.get('categories');
      return _.isArray(categories) ? categories : [];
    },

    hasCategory: function (id) {
      return _.some(this.getCategories(), function (category) {
        return parseInt(category.id, 10) === parseInt(id, 10);
      });
    },

    setDefaultCategory: function (id) {
      var defer = $.Deferred();

      if (this.getDefaultCategoryId() === id) {
        defer.resolve();
        return defer.promise();
      }

      var data = {
        productId: this.getId(),
        categoryId: id
      };

      $.ajax({
        type: 'PUT',
        url: Settings.url('compuzz2', 'webshop/product/categories/default/update'),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function () {
          defer.resolve();
        },
        error: function (data) {
          defer.reject(data.responseJSON.message);
        }
      });
      return defer.promise();
    },

    addCategory: function (id) {
      var defer = $.Deferred();

      var data = {
        productIds: [this.getId()],
        categoryId: id
      };

      $.ajax({
        type: 'PUT',
        url: Settings.url('compuzz2', 'webshop/category/products/add'),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function () {
          defer.resolve();
        },
        error: function (data) {
          defer.reject(data.responseJSON.message);
        }
      });
      return defer.promise();
    },

    deleteCategory: function (id) {
      var defer = $.Deferred();

      var data = {
        productId: this.getId(),
        categoryId: id
      };

      $.ajax({
        type: 'PUT',
        url: Settings.url('compuzz2', 'webshop/category/products/delete'),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function () {
          defer.resolve();
        },
        error: function (data) {
          defer.reject(data.responseJSON.message);
        }
      });
      return defer.promise();
    },

    getPosition: function () {
      return this.get('position');
    },

    getLabel: function () {
      return this.get('label');
    },

    setLabel: function (value) {
      var defer = $.Deferred();

      if (this.getLabel() === value) {
        defer.resolve();
        return defer.promise();
      }

      this.update('label/update', value).done(_.bind(function () {
        defer.resolve();
      }, this)).fail(_.bind(function (e) {
        defer.reject(e);
      }, this));

      return defer.promise();
    },

    getYoutubeVideo: function () {
      return this.get('youtubeVideo');
    },

    setYoutubeVideo: function (value) {
      return this.setText('youtube-video', 'fr', value);
    },

    update: function(url, value) {
      var defer = $.Deferred();
      var data = {
        id: this.getId(),
        code: this.getCode(),
        value: value
      };

      $.ajax({
        type: 'PUT',
        url: Settings.url('compuzz2', 'webshop/product/' + url),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function () {
          defer.resolve();
        },
        error: function (data) {
          defer.reject(data);
        }
      });
      return defer.promise();
    },

    clearCache: function () {
      var defer = $.Deferred();
      var data = {
        id: this.getId()
      };

      $.ajax({
        type: 'PUT',
        url: Settings.url('compuzz2', 'webshop/product/clean-cache'),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function () {
          defer.resolve();
        },
        error: function (data) {
          defer.reject(data);
        }
      });
      return defer.promise();
    },

    setSlug: function (lang, value) {
      return this.setText('url', lang, value);
    },

    getSlug: function (lang) {
      if (lang)
        return this.getText('url', lang);
      else
        return this.getText('url');
    },

    getName: function (lang) {
      return this.getText('name', lang);
    },

    setName: function (lang, value) {
      return this.setText('name', lang, value);
    },

    getDescription: function (lang) {
      return this.getText('long', lang);
    },

    setDescription: function (lang, value) {
      return this.setText('long', lang, value);
    },

    getExtraDescription: function (lang) {
      return this.getText('extra-description', lang);
    },

    setExtraDescription: function (lang, value) {
      return this.setText('extra-description', lang, value);
    },

    getMetaTitle: function (lang) {
      return this.getText('meta-title', lang);
    },

    setMetaTitle: function (lang, value) {
      return this.setText('meta-title', lang, value);
    },

    getMetaDescription: function (lang) {
      return this.getText('meta-description', lang);
    },

    setMetaDescription: function (lang, value) {
      return this.setText('meta-description', lang, value);
    },

    getIndex: function (lang) {
      var result = false;

      if(this.get('seoIndexes')) {
        if(this.get('seoIndexes')[lang] !== undefined)
          result = !this.get('seoIndexes')[lang];
      }

      return result;
    },

    setIndex: function (lang, value) {
      var defer = $.Deferred();

      if (this.getIndex(lang) === value) {
        defer.resolve();
        return defer.promise();
      }

      var data = {
        productId: this.getId(),
        lang: lang,
        value: value
      };

      $.ajax({
        type: 'PUT',
        url: Settings.url('compuzz2', 'webshop/product/seo/index/update'),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function () {
          defer.resolve();
        },
        error: function (data) {
          defer.reject(data);
        }
      });
      return defer.promise();
    },

    getSupplierCode: function () {
      var result = true;
      _.each(this.get('properties'), _.bind(function (p) {
        if (p.type === 'supplier-code')
          result = p.value;
      }, this));

      return result;
    },

    getSupplierName: function () {
      var result = true;
      _.each(this.get('properties'), _.bind(function (p) {
        if (p.type === 'supplier-name')
          result = p.value;
      }, this));

      return result;
    },

    getText: function (type, lang) {
      if (!lang)
        lang = Settings.get('lang');

      var text = '';
      if (this.get('texts')) {
        _.each(this.get('texts'), _.bind(function (t) {
          if (t.type === type && t.lang === lang)
            text = t.content;
        }, this));
      }
      return text;
    },

    setText: function (type, lang, value) {
      var defer = $.Deferred();

      if (this.getText(type, lang) === value) {
        defer.resolve();
        return defer.promise();
      }

      var data = {
        productCode: this.getCode(),
        code: type,
        lang: lang,
        content: value
      };

      $.ajax({
        type: 'PUT',
        url: Settings.url('compuzz2', 'webshop/product/text/update'),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function () {
          defer.resolve();
        },
        error: function (error) {
          defer.reject(error);
        }
      });
      return defer.promise();
    },

    getPreviewImageUrl: function () {
      var url = Settings.get('notFoundImage');
      if (this.get('medias')) {
        _.each(this.get('medias'), _.bind(function (media) {
          if (media.type === 'default')
            url = Settings.configValue('webshop.imagesUrl') + '/' + media.previewUrl;
        }, this));
      }
      return url;
    },

    getImageUrls: function () {
      var urls = [];
      if (this.get('medias')) {
        _.each(this.get('medias'), _.bind(function (media) {
          urls.push(Settings.configValue('webshop.imagesUrl') + '/' + media.url);
        }, this));
      }
      return urls;
    },

    getImages: function (type) {

      var images = [];

      _.each(this.get('medias'), _.bind(function (media) {
        if (media.type === type)
          images.push(media);
      }, this));

      return images;
    },

    addImage: function (file, type, lang) {
      var defer = $.Deferred();

      var data = new FormData();
      data.append('file', file);
      data.append('code', this.getCode());
      data.append('type', type);
      if (lang)
        data.append('lang', lang);

      $.ajax({
        type: 'POST',
        url: Settings.url('compuzz2', 'webshop/product/images/add'),
        data: data,
        processData: false,
        contentType: false,
        success: function (result) {
          var image = null;
          if(result.image)
            image = result.image;
          defer.resolve(image);
        },
        error: function (error) {
          defer.reject(error);
        }
      });
      return defer.promise();
    },

    updateImageLanguage: function (id, lang) {
      var defer = $.Deferred();

      var data = {
        productCode: this.getCode(),
        id: id,
        lang: lang || null
      };

      $.ajax({
        type: 'POST',
        url: Settings.url('compuzz2', 'webshop/product/images/language/update'),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function () {
          defer.resolve();
        },
        error: function () {
          defer.reject();
        }
      });
      return defer.promise();
    },

    deleteImage: function (id) {
      var defer = $.Deferred();

      var data = {
        productCode: this.getCode(),
        id: id
      };

      $.ajax({
        type: 'POST',
        url: Settings.url('compuzz2', 'webshop/product/images/delete'),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function () {
          defer.resolve();
        },
        error: function () {
          defer.reject();
        }
      });
      return defer.promise();
    },

    getTag: function () {
      return this.get('tag');
    },

    setTag: function (id) {
      var defer = $.Deferred();

      if (this.getTag() === id) {
        defer.resolve();
        return defer.promise();
      }

      var data = {
        productId: this.getId(),
        id: id
      };

      $.ajax({
        type: 'PUT',
        url: Settings.url('compuzz2', 'webshop/product/tag/update'),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function () {
          defer.resolve();
        },
        error: function () {
          defer.reject();
        }
      });
      return defer.promise();
    },

    getLayout: function () {
      var id = '';
      if (this.get('config')) {
        _.each(this.get('config'), _.bind(function (value, code) {
          if (code === 'layout')
            id = value;
        }, this));
      }
      return id;
    },

    setLayout: function (id) {
      var defer = $.Deferred();

      if (this.getLayout() === id) {
        defer.resolve();
        return defer.promise();
      }

      this.update('layout/update', id).done(_.bind(function () {
        defer.resolve();
      }, this)).fail(_.bind(function (e) {
        defer.reject(e);
      }, this));

      return defer.promise();
    },

    getOutdated: function () {
      return this.get('outdated');
    },

    setOutdated: function (value) {
      var defer = $.Deferred();

      if (this.getOutdated() === value) {
        defer.resolve();
        return defer.promise();
      }

      var data = {
        productId: this.getId(),
        value: value
      };

      $.ajax({
        type: 'PUT',
        url: Settings.url('compuzz2', 'webshop/product/outdated/update'),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function () {
          defer.resolve();
        },
        error: function () {
          defer.reject();
        }
      });
      return defer.promise();
    },

    getDisabledSites: function () {
      /*jshint camelcase: false */
      var config = this.get('config') || {};
      var disabled = config.disabled_sites;
      return _.isArray(disabled) ? disabled : [];
    },

    setDisabledSites: function (siteIds) {
      var defer = $.Deferred();

      var data = {
        productId: this.getId(),
        disabledSites: _.isArray(siteIds) ? siteIds : []
      };

      $.ajax({
        type: 'PUT',
        url: Settings.url('compuzz2', 'webshop/product/disabled-sites/update'),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: _.bind(function (response) {
          /*jshint camelcase: false */
          var config = _.extend({}, this.get('config') || {});
          config.disabled_sites = (response && response.disabledSites) || data.disabledSites;
          this.set('config', config);
          defer.resolve(config.disabled_sites);
        }, this),
        error: function (xhr) {
          defer.reject(xhr && xhr.responseJSON ? xhr.responseJSON : xhr);
        }
      });
      return defer.promise();
    },

    getUnfinished: function () {
      return this.get('unfinished');
    },

    setUnfinished: function (value) {
      var defer = $.Deferred();

      if (this.getUnfinished() === value) {
        defer.resolve();
        return defer.promise();
      }

      var data = {
        productId: this.getId(),
        value: value
      };

      $.ajax({
        type: 'PUT',
        url: Settings.url('compuzz2', 'webshop/product/unfinished/update'),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function () {
          defer.resolve();
        },
        error: function () {
          defer.reject();
        }
      });
      return defer.promise();
    },

    getUploadLogo: function () {
      return this.get('uploadLogo');
    },

    setUploadLogo: function (value) {
      var defer = $.Deferred();

      if (this.getUploadLogo() === value) {
        defer.resolve();
        return defer.promise();
      }

      if(value === true)
        value = 'true';
      else
        value = 'false';

      this.update('logo-upload/update', value).done(_.bind(function () {
        defer.resolve();
      }, this)).fail(_.bind(function (e) {
        defer.reject(e);
      }, this));

      return defer.promise();
    },

    getCompositionEditor: function () {
      var value = false;
      if (this.get('attributes')) {
        _.each(this.get('attributes'), _.bind(function (attribute) {
          if (attribute.type === 'allow-editor')
            value = true;
        }, this));
      }
      return value;
    },

    setCompositionEditor: function (value) {
      var defer = $.Deferred();

      if (this.getCompositionEditor() === value) {
        defer.resolve();
        return defer.promise();
      }

      this.update('composition-editor/update', value).done(_.bind(function () {
        defer.resolve();
      }, this)).fail(_.bind(function (e) {
        defer.reject(e);
      }, this));

      return defer.promise();
    },

    getGoogleShopping: function () {
      return this.get('googleShopping');
    },

    setGoogleShopping: function (value) {
      var defer = $.Deferred();

      if (this.getGoogleShopping() === value) {
        defer.resolve();
        return defer.promise();
      }

      this.update('google-shopping/update', value).done(_.bind(function () {
        defer.resolve();
      }, this)).fail(_.bind(function (e) {
        defer.reject(e);
      }, this));

      return defer.promise();
    },

    redirect: function (targetDomain, targetId, type) {
      var defer = $.Deferred();

      if (targetDomain === 'product' && parseInt(targetId, 10) === this.getId()) {
        defer.reject({selfRedirect: true});
        return defer.promise();
      }

      var data = {
        originDomain: 'product',
        originId: this.getId(),
        targetDomain: targetDomain,
        targetId: targetId,
        type: type
      };

      $.ajax({
        type: 'POST',
        url: Settings.url('compuzz2', 'webshop/urls/redirect'),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function () {
            defer.resolve();
        },
        error: function (data) {
            defer.reject(data);
        }
      });

      return defer.promise();
    },

    removeRedirection: function () {
      var defer = $.Deferred();

      var data = {
        domain: 'product',
        id: this.getId()
      };

      $.ajax({
        type: 'POST',
        url: Settings.url('compuzz2', 'webshop/urls/remove-redirection'),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function () {
          defer.resolve();
        },
        error: function () {
          defer.reject();
        }
      });

      return defer.promise();
    }
  });

  var API = {
    create: function (data) {
      data.outdated = false;
      data.tag = '';
      data.uploadLogo = false;
      data.googleShopping = false;
      data.youtubeVideo = '';
      data.seoIndexes = {};

      if (data.attributes) {
        _.each(data.attributes, _.bind(function (attribute) {
          if (attribute.type === 'out-dated')
            data.outdated  = true;

          if (attribute.type === 'product-sort')
            data.tag = attribute.id;

          if (attribute.type === 'google' && attribute.code === 'google-shopping')
            data.googleShopping = true;
        }, this));
      }

      if (data.properties) {
        _.each(data.properties, _.bind(function (property) {
          if (property.type === 'logo-upload')
          {
            if(property.value === 'true')
              data.uploadLogo = true;
            else
              data.uploadLogo = false;
          }

          if (property.type === 'noindex')
            data.seoIndexes = JSON.parse(property.value);
        }, this));
      }

      if (data.texts) {
        _.each(data.texts, _.bind(function (text) {
          if (text.type === 'youtube-video')
            data.youtubeVideo = text.content;
        }, this));
      }

      return data;
    },

    findSupplierNames: function (query) {
      var defer = $.Deferred();

      $.ajax({
        type: 'GET',
        url: Settings.url('compuzz2', 'webshop/products/findSupplierNames', {value: query}),
          success: function (data) {
          defer.resolve(data);
        },
          error: function () {
          defer.reject();
        }
      });
      return defer.promise();
    },

    getTags: function () {
      var defer = $.Deferred();
      if (this.tags)
        defer.resolve(this.tags);
      else {
        $.ajax({
          type: 'GET',
          url: Settings.url('compuzz2', 'webshop/products/tags'),
          success: _.bind(function (tags) {
            this.tags = new Backbone.Collection(tags);
            defer.resolve(this.tags);
          }, this)
        });
      }
      return defer.promise();
    },

    deleteHistory: function (id, lang, value) {
      var defer = $.Deferred();

      var data = {
        id: id,
        lang: lang,
        value: value
      };

      $.ajax({
        type: 'DELETE',
        url: Settings.url('compuzz2', 'webshop/product/index/history'),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function () {
          defer.resolve();
        },
        error: function () {
          defer.reject();
        }
      });
      return defer.promise();
    },

    getImagesTypes: function () {
      var defer = $.Deferred();

      $.ajax({
        type: 'GET',
        url: Settings.url('compuzz2', 'webshop/products/images/types', {}),
        success: _.bind(function (types) {
          defer.resolve(types);
        }, this)
      });
      return defer.promise();
    }
  };

  App.reqres.setHandler('webshop.product.model', function (data) {
    if (!data)
      data = {};
    return app.ns.WebshopProduct.findOrCreate(API.create(data));
  });

  App.reqres.setHandler('webshop.products.search', function (params) {
    return Settings.url('compuzz2', 'webshop/products/search', params);
  });

  App.reqres.setHandler('webshop.products.count', function (params) {
    return Settings.url('compuzz2', 'webshop/products/count', params);
  });

  // categories of several products in one call: {productId: [{id, code, name}]}
  App.reqres.setHandler('webshop.products.categories', function (params) {
    return Settings.url('compuzz2', 'webshop/products/categories', params);
  });

  App.reqres.setHandler('webshop.products.findSupplierNames', function (query) {
    return API.findSupplierNames(query);
  });

  App.reqres.setHandler('webshop.products.tags', function () {
    return API.getTags();
  });

  App.reqres.setHandler('webshop.products.images.types', function () {
    return API.getImagesTypes();
  });

  App.reqres.setHandler('webshop.product.history', function (code, params) {
    return Settings.url('compuzz2', 'webshop/product/' + code + '/index/history', params);
  });

  App.reqres.setHandler('webshop.product.history.count', function (code, params) {
    return Settings.url('compuzz2', 'webshop/product/' + code + '/index/history/count', params);
  });

  App.reqres.setHandler('webshop.product.history.delete', function (id, lang, value) {
    return API.deleteHistory(id, lang, value);
  });

  App.reqres.setHandler('webshop.product.categories', function (id, params) {
    return Settings.url('compuzz2', 'webshop/product/' + id + '/categories', params);
  });

  App.reqres.setHandler('webshop.product.urls', function (params) {
    return Settings.url('compuzz2', 'webshop/product/urls', params);
  });

  App.reqres.setHandler('webshop.product.categories.count', function (id, params) {
    return Settings.url('compuzz2', 'webshop/product/' + id + '/categories/count', params);
  });

});

